var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { AvailabilityUtility } from '@inter-ikea-kompis/utilities';
import { QrCode } from '@inter-ikea-kompis/component-qr-code';
import { Text } from '@ingka/common-styles-webc';
import { informationCircle, registerIcon } from '@ingka/icon-store';
import { Icon as SkapaIcon } from '@ingka/icon-webc/passive.js';
import { InlineMessage as SkapaInlineMessage } from '@ingka/inline-message-webc/passive.js';
import BuyInStoreCardStyle from './BuyInStoreCardStyle.js';
/**
 * Card to show QR code in Kiosks. Used in BuyInStore.
 */
export default class BuyInStoreCard extends KompisElement {
    constructor() {
        super(...arguments);
        // Localized information. Deprecated - use "translations" instead.
        this.localizedInformation = null;
        // The translations retrieved from translations service.
        this.translations = null;
        // A list of store availability objects.
        this.storeAvailabilities = null;
        // Link used in the QR code to take the user to the summary page on their phone. This should link directly to the picking list of the summary page.
        this.buyInStoreLink = null;
    }
    async connectedCallback() {
        registerIcon(informationCircle);
        this.customElements.define('skapa-inline-message', SkapaInlineMessage);
        this.customElements.define('skapa-icon', SkapaIcon);
        this.customElements.define('kompis-qr-code', QrCode);
        super.connectedCallback();
    }
    render() {
        // We want translations to be required, but since both props to provide translations are optional, this check is needed until localizedInformation is removed.
        if (!this.hasTranslations()) {
            // We can't throw an error because on the first render no props are set.
            return null;
        }
        return html `
			<style>
				${BuyInStoreCardStyle.getStyle()}
			</style>
			${this.getHeading()} ${this.getBody()} ${this.getQrCodeContainer()}
		`;
    }
    hasTranslations() {
        return !!this.translations || !!this.localizedInformation?.translations;
    }
    getTranslations() {
        const translations = this.translations
            ? this.translations
            : this.localizedInformation?.translations;
        return translations;
    }
    getHeading() {
        return html `
			<h2 class="heading ${Text.classnames({ heading: { m: true } })}">
				${this.getTranslations().continueOnMobileHeading}
			</h2>
		`;
    }
    getBody() {
        return html `
			<p class="body ${Text.classnames({ body: { m: true } })}">
				${this.getTranslations().continueOnMobileDescription}
			</p>

			${this.getFullServeMessage()}
		`;
    }
    getFullServeMessage() {
        if (!this.showFullServeMessage()) {
            return null;
        }
        const variant = 'informative';
        return html `
			<skapa-inline-message subtle class="message" variant="${variant}">
				<skapa-icon slot="message-icon" icon="information-circle"></skapa-icon>
				<span slot="body">${this.getTranslations().buyInStoreFullServeMessage}</span>
			</skapa-inline-message>
		`;
    }
    getQrCodeContainer() {
        return html `<div class="qr-code-container">
			${this.getQrCode()}
			<p class="qr-code-help-text ${Text.classnames({ body: { m: true } })}">
				${this.getTranslations().continueOnMobileQrCodeHelpText}
			</p>
		</div>`;
    }
    getQrCode() {
        if (!this.buyInStoreLink) {
            return null;
        }
        const { buyInStoreQrCodeTitle } = this.getTranslations();
        return html `
			<div class="qr-code-background">
				<kompis-qr-code
					url="${this.buyInStoreLink}"
					qrCodeTitle="${buyInStoreQrCodeTitle}"
				></kompis-qr-code>
			</div>
		`;
    }
    showFullServeMessage() {
        if (!this.storeAvailabilities) {
            return false;
        }
        return AvailabilityUtility.hasAnyFullServeAvailability(this.storeAvailabilities);
    }
}
__decorate([
    property({ type: Object })
], BuyInStoreCard.prototype, "localizedInformation", void 0);
__decorate([
    property({ type: Object })
], BuyInStoreCard.prototype, "translations", void 0);
__decorate([
    property({ type: Array })
], BuyInStoreCard.prototype, "storeAvailabilities", void 0);
__decorate([
    property({ type: String })
], BuyInStoreCard.prototype, "buyInStoreLink", void 0);
//# sourceMappingURL=BuyInStoreCard.js.map